/**
 * Reaching one of these routes means the booking is placed, so any claim behind
 * a lookup has been marked used and its cached validation must be discarded
 * (RPD-25).
 */
const JOURNEY_COMPLETE_ROUTE = /\/(confirmation|thankyou)(\/|$)/;

export function isJourneyCompleteUrl(url: string): boolean {
	// Compare the path alone: a booking id in the query or a fragment must not
	// stop the route matching.
	return JOURNEY_COMPLETE_ROUTE.test(url.split(/[?#]/)[0]);
}
